import { render, staticRenderFns } from "./SendTestQuery.vue?vue&type=template&id=542517c2&scoped=true&"
import script from "./SendTestQuery.vue?vue&type=script&lang=js&"
export * from "./SendTestQuery.vue?vue&type=script&lang=js&"
import style0 from "./SendTestQuery.vue?vue&type=style&index=0&id=542517c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542517c2",
  null
  
)

export default component.exports